'use es6';

import { Map as ImmutableMap } from 'immutable';
import get from 'transmute/get';
import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
export const formatWorkflows = formatToReferencesList({
  getId: get('flowId'),
  // `name` should always be available on the object, but historically was not
  // required, so to be 100% safe from providing nothing use `flowId` as a fallback
  getLabel: workflow => get('name', workflow) || `${get('flowId', workflow)}`
});
export const formatWorkflowsPaged = response => {
  const {
    results,
    offset,
    hasMore,
    total
  } = response;
  return ImmutableMap({
    count: total,
    hasMore,
    results: formatWorkflows(results),
    offset: offset || 0
  });
};